import React, { useEffect, useState, useRef } from 'react'
import { Globe, ChevronDown } from 'lucide-react'
import { useTranslation } from '../i18n'

export function LanguageSelector() {
  const { setLanguage: changeLanguage, language: currentLanguage, dir } = useTranslation();
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [])
  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-center gap-1.5 px-3 py-2 rounded-md hover:text-primary-500 hover:bg-white/10 transition-all duration-300 w-full sm:w-auto"
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <Globe size={16} className="flex-shrink-0" />
        <span className="text-sm font-medium mx-1">
          {currentLanguage.toUpperCase()}
        </span>
        <ChevronDown
          size={14}
          className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      {isOpen && (
        <div
          className={`absolute top-full mt-1 ${dir === 'ltr' ? 'left-0' : 'right-0'} w-full sm:w-40 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-100 animate-fade-in`}
          role="menu"
          aria-orientation="vertical"
        >
          <div className="max-h-60 overflow-y-auto">
            <button
              onClick={() => {
                changeLanguage('en')
                setIsOpen(false)
              }}
              className={`w-full flex items-center justify-center px-4 py-2.5 text-sm ${currentLanguage === 'en' ? 'bg-primary-50 text-primary-500 font-medium' : 'text-gray-700 hover:bg-gray-50'} transition-colors duration-200`}
              role="menuitem"
            >
              English
            </button>
            <button
              onClick={() => {
                changeLanguage('ar')
                setIsOpen(false)
              }}
              className={`w-full flex items-center justify-center px-4 py-2.5 text-sm ${currentLanguage === 'ar' ? 'bg-primary-50 text-primary-500 font-medium' : 'text-gray-700 hover:bg-gray-50'} transition-colors duration-200`}
              role="menuitem"
            >
              العربية
            </button>
            <button
              onClick={() => {
                changeLanguage('ku')
                setIsOpen(false)
              }}
              className={`w-full flex items-center justify-center px-4 py-2.5 text-sm ${currentLanguage === 'ku' ? 'bg-primary-50 text-primary-500 font-medium' : 'text-gray-700 hover:bg-gray-50'} transition-colors duration-200`}
              role="menuitem"
            >
              کوردی
            </button>
          </div>
        </div>
      )}
    </div>
  )
}